import React, { FC } from 'react';

import { usePreview } from '@/scenarios/legacy-player/components/PlayerSkin/parts/TimelineMarks/hooks/usePreview';

import { TimelinePreview } from '../../../feature-player/ui/skin/timeline-preview/component';
import { Time } from '../../../feature-player/ui/skin/timeline/types/time';
import { useTiles } from '../../hooks/use-tiles';

interface EpisodeTimelinePreviewContainerProps {
    contentId: string;
    time: Time;
}

export const EpisodeTimelinePreviewContainer: FC<EpisodeTimelinePreviewContainerProps> = ({
    contentId,
    time,
}) => {
    const tiles = useTiles(contentId);

    const preview = usePreview({
        time: time.streamTime,
        config: tiles || null,
        isMetaFromStreams: true,
    });

    return <TimelinePreview time={time} preview={preview || undefined} />;
};
